<ul id="link-flex-dropdown" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="link-flex">
  <li *ngFor="let flex of flexs" role="menuitem">
    <span (click)="onSelectFlex(flex)" class="dropdown-item">{{ flex.name }}</span>
  </li>
</ul>
